import React from 'react';
import { SwitchInput, createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import styles from './styles';
const useStyles = createUseStyles(styles, 'Switch');

function Switch({ value, className, ...props }) {
    const classes = useStyles();
    const classNames = classnames(className, classes.root);

    return (
        <SwitchInput
            labelMode="horizontal"
            value={value}
            className={classNames}
            {...props}
            isFullWidth={false}
        />
    );
}

export default Switch;
